import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { splash1, splash2, splash3, splash4, splash5 } from '../../assets/images';
import { RoutesE } from '../../routes/routesData';
import { useAppDispatch } from '../../store/hooks';
import { login } from '../../store/slices/authSlice';
import { clss } from '../../utils/helpers/styleHelpers';
import { getLoggedUser } from '../../utils/helpers/tokenStorage';

import styles from './styles.module.scss';

const AnimatedBackground = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [animation1, setAnimation1] = useState(false);
    const [animation2, setAnimation2] = useState(false);
    const [animation3, setAnimation3] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setAnimation1(true);
        }, 2000);
        setTimeout(() => {
            setAnimation2(true);
        }, 2500);
        setTimeout(() => {
            setAnimation3(true);
        }, 3000);
    }, []);

    return (
        <div className={styles.splashWrapper}>
            <img src={splash5} alt="" className={styles.splashClouds} />
            <img src={splash1} alt="" className={clss([styles.splashIconLeft, animation1 ? styles.vibrate : ''])} />
            <img src={splash2} alt="" className={clss([styles.splashIconRight, animation2 ? styles.vibrate : ''])} />
            <img src={splash3} alt="" className={clss([styles.splashIconBottom, animation3 ? styles.vibrate : ''])} />
            <img src={splash4} alt="" className={styles.splashSparks} />
        </div>
    );
};

export default AnimatedBackground;